// extracted by mini-css-extract-plugin
export default {"gauge":"GaugeChart_gauge__HymhL"};